module.exports = __webpack_public_path__ + "static/Basil-pesto-d6d9a3dcfd4a6d75d03bd10e26838fe2.png";